import { CheckCircle2 } from 'lucide-react';
import { FadeIn, Stagger, StaggerItem } from '@/components/motion/FadeIn';
import { MaskReveal } from '@/components/motion/Reveal';

interface Step {
  step: number;
  title: string;
  description: string;
  deliverables: string[];
}

interface Props {
  items: Step[];
}

export function HomeProcess({ items }: Props) {
  if (!items || items.length === 0) return null;
  return (
    <MaskReveal className="section-y-lg bg-bg-subtle/30" tilt={-1.2} duration={1.15}>
      <div className="container-wide">
        <FadeIn>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">Our process</p>
          <h2 className="mt-3 text-h2 text-fg">A path from idea to production.</h2>
        </FadeIn>

        <Stagger className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {items.map((step) => (
            <StaggerItem key={step.step}>
              <div className="relative h-full rounded-xl border border-border bg-bg-elevated/40 p-6">
                <span className="display-serif text-5xl text-gold-500/40">
                  {String(step.step).padStart(2, '0')}
                </span>
                <h3 className="mt-2 text-xl font-semibold tracking-tight">{step.title}</h3>
                <p className="mt-2 text-sm text-fg-muted">{step.description}</p>
                {step.deliverables && step.deliverables.length > 0 && (
                  <ul className="mt-4 space-y-1.5">
                    {step.deliverables.map((d) => (
                      <li key={d} className="flex items-start gap-2 text-xs text-fg-muted">
                        <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-500" />
                        {d}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </MaskReveal>
  );
}